import { Box, Flex, FormLabel, forwardRef, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

interface ISquareSwitch {
  label1: string
  label2: string
  initialValue?: string
  onToggle: (value: string) => void
  label?: string
  boxMargin?: string
}

const SquareSwitch = forwardRef((props: ISquareSwitch, ref) => {
  const { label1, label2, initialValue, onToggle, label, boxMargin, ...rest } = props

  const [currentSelected, setCurrentSelected] = useState(initialValue ?? label1)

  useEffect(() => {
    onToggle(currentSelected)
  }, [currentSelected])

  const SquareSwitchElement = () => {
    return (
      <Flex
        role='switch'
        width='fit-content'
        alignItems='center'
        cursor='pointer'
        userSelect='none'
        ref={ref}
        {...rest}
      >
        <Text
          bgColor={label1 === currentSelected ? 'tertiary.200' : 'white'}
          color={label1 === currentSelected ? 'tertiary.800' : 'black'}
          minWidth='2rem'
          paddingY='2'
          paddingX='10'
          border='solid 1px gray'
          borderLeftRadius='md'
          borderColor='tertiary.600'
          onClick={(e) => setCurrentSelected(e.currentTarget.innerText)}
        >
          {label1}
        </Text>
        <Text
          bgColor={label1 !== currentSelected ? 'tertiary.200' : 'white'}
          color={label1 !== currentSelected ? 'tertiary.800' : 'black'}
          minWidth='2rem'
          paddingY='2'
          paddingX='10'
          border='solid 1px gray'
          borderLeft='none'
          borderRightRadius='md'
          borderColor='tertiary.600'
          onClick={(e) => setCurrentSelected(e.currentTarget.innerText)}
        >
          {label2}
        </Text>
      </Flex>
    )
  }

  if (label) {
    return (
      <Box margin={boxMargin} display='flex' flexDirection='column'>
        <FormLabel fontSize='md'>{label}</FormLabel>
        <SquareSwitchElement />
      </Box>
    )
  }

  return <SquareSwitchElement />
})

export { SquareSwitch }
